/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "Address",
      "AuthGroup",
      "Group",
      "SAPCustomer",
      "ScgUser",
      "ScgUserDetail",
      "ShopTranslation",
      "StaffNotificationRecipient",
      "User"
    ],
    "ObjectWithMetadata": [
      "SAPCustomer",
      "ScgUser",
      "ScgUserDetail",
      "User"
    ],
    "_Entity": [
      "Address",
      "Group",
      "User"
    ]
  }
};
      export default result;
    